import { FlexBox } from "@brg/ui"
import { LayoutConst } from "core/modules/layout.module"
import ArrowRight from "shared/assets/24/ArrowRight"
import { BrgButton } from "shared/components/buttons"
import styled from "styled-components"


export const BottomBar = styled.div`
    position: fixed;
    bottom: 0;
    left: 0;
    background: ${({ theme }) => theme.hoverModal.bg.color};
    width: 100%;
    z-index: 100000;
    padding: 16px;

    @media (max-width: ${LayoutConst.screen.m}px) {
        padding: 16px 10px 8px 10px;
    }
`

export const BottomBarContent = styled(FlexBox)`
    margin: 0 auto;
    display: flex;
    // justify-content: space-between;
    max-width: 1152px;
    align-items: center;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        max-width: 888px;
    }

    @media (max-width: ${LayoutConst.screen.m}px) {
        align-items: flex-start;
        flex-direction: column;
        gap: 8px;
    }
`

export const ButtonHolder = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 16px;

    @media (max-width: ${LayoutConst.screen.m}px) {
        width: 100%;
        gap: 8px;
    }
`

export const ProjectName = styled.div`

    font-family: Inter;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 25px;
    letter-spacing: -0.4px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 17px;
        line-height: 22px;
        letter-spacing: -0.34px;
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        font-size: 15px;
        line-height: 20px;
        letter-spacing: -0.3px;
    }

    @media (max-width: ${LayoutConst.screen.l_12}px) {
        font-size: 15px;
        line-height: 20px;
        letter-spacing: -0.3px;
    }
`

export const Button = styled(BrgButton)`
    @media (max-width: ${LayoutConst.screen.m}px) {
        flex: 1;
    }
`

export const ArrowRightIcon = styled(ArrowRight)`
    margin-left: 8px;

    @media (max-width: ${LayoutConst.screen.m}px) {
        display: none;
    }
`

export const TopBar = styled(FlexBox)`
    width: 100%;
    margin-bottom: 16px;
`

export const BackButtonWrapper = styled.div`
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    color: #909090;
    cursor: pointer;
    align-items: center;

    &:hover {
        color: ${({ theme }) => theme.sendProjectsModal.title};
        svg path {
        fill: ${({ theme }) => theme.sendProjectsModal.title};
        }
    }
`

export const LeftColumn = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`import { FlexBox } from "@brg/ui"
import { LayoutConst } from "core/modules/layout.module"
import ArrowRight from "shared/assets/24/ArrowRight"
import { BrgButton } from "shared/components/buttons"
import styled from "styled-components"


export const BottomBar = styled.div`
    position: fixed;
    bottom: 0;
    left: 0;
    background: ${({ theme }) => theme.hoverModal.bg.color};
    width: 100%;
    z-index: 100000;
    padding: 16px;

    @media (max-width: ${LayoutConst.screen.m}px) {
        padding: 16px 10px 8px 10px;
    }
`

export const BottomBarContent = styled(FlexBox)`
    margin: 0 auto;
    display: flex;
    // justify-content: space-between;
    max-width: 1152px;
    align-items: center;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        max-width: 888px;
    }

    @media (max-width: ${LayoutConst.screen.m}px) {
        align-items: flex-start;
        flex-direction: column;
        gap: 8px;
    }
`

export const ButtonHolder = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 16px;

    @media (max-width: ${LayoutConst.screen.m}px) {
        width: 100%;
        gap: 8px;
    }
`

export const ProjectName = styled.div`

    font-family: Inter;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 25px;
    letter-spacing: -0.4px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 17px;
        line-height: 22px;
        letter-spacing: -0.34px;
    }

    @media (max-width: ${LayoutConst.screen.s}px) {
        font-size: 15px;
        line-height: 20px;
        letter-spacing: -0.3px;
    }

    @media (max-width: ${LayoutConst.screen.l_12}px) {
        font-size: 15px;
        line-height: 20px;
        letter-spacing: -0.3px;
    }
`

export const Button = styled(BrgButton)`
    @media (max-width: ${LayoutConst.screen.m}px) {
        flex: 1;
    }
`

export const ArrowRightIcon = styled(ArrowRight)`
    margin-left: 8px;

    @media (max-width: ${LayoutConst.screen.m}px) {
        display: none;
    }
`

export const TopBar = styled(FlexBox)`
    width: 100%;
    margin-bottom: 16px;
`

export const BackButtonWrapper = styled.div`
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    color: #909090;
    cursor: pointer;
    align-items: center;

    &:hover {
        color: ${({ theme }) => theme.sendProjectsModal.title};
        svg path {
        fill: ${({ theme }) => theme.sendProjectsModal.title};
        }
    }
`

export const LeftColumn = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`